module.exports = __webpack_public_path__ + "static/media/derecho-familia.0584b8b3.jpg";